<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar';
import 'zrender/lib/svg/svg'
export default {
    name:"char1",
    components:{
         'v-chart': ECharts
    },
    props:{
        data:Object,
        datelist:{
            type:Array,
            default:()=>{
              return []
            }
        }
    },
    data(){
        return {
            option:{},
             viewdata:{},
      viewdate:[],
        timer:false
        }
    },
    watch:{
        datelist:{
            handler(){  
                          
              this.dataInit();
              this.init()
            
            },
            deep:false
        }
    },
    methods:{
         dataInit(){              
             
            this.viewdata.data1= this.data.past.slice(0,5); 
            this.viewdata.data2= this.data.comeIn.slice(0,5); 
            this.viewdata.data3= this.data.fittingNum.slice(0,5); 
            this.viewdata.data4= this.data.saleTotal.slice(0,5);    
            // debugger   
            this.viewdate=this.datelist.slice(0,5)     
        //    this.viewdate.length>0?this.viewdate=this.datelist.slice(0,5):[];    
            
           this.doit()
        },
        init(){      
            let that=this      
              this.option={
                grid: {
                    top:'10%',
                    left: '5%',
                    right: '5%',
                    bottom:'10%',
                    containLabel: true
                },
                legend: {
                    bottom:'2%',
                    itemWidth:6,
                    itemHeight:6,
                    textStyle:{
                        color:"#fff"
                    },
                    icon:"rect",
                    data: ['路过客流', '进店客流','销售额','试衣数']
                },
                tooltip:{
                    position:['50%', '50%'],
                    formatter: function(params,index) { 
                    　　var result = params[0].name+'</br>'
                    　　params.forEach(function (item) {  
                            if(item.seriesId=="a1"){ 
                                result += item.seriesName +":"+ item.data + "</br>"
                            }else if(item.seriesId=="a2"){ //活跃会员数                            
                                if(item.data>10000){
                              　    result += item.seriesName +":"+ (item.data/10000) + "万</br>"
                                }
                                else{                                
                                  　result += item.seriesName +":"+ item.data + "</br>"
                                }
                            }else if(item.seriesId=="a3"){ //活跃会员数                            
                                result += item.seriesName +":"+ item.data + "</br>"
                            }                            
                            else{
                              result += item.seriesName +":"+ item.data + "</br>"
                            }                          
                           
                    　　})                   
                    　　return result                
                    },
                    textStyle:{
                        fontSize:this.chartFontSize-4
                    },
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",      
                        shadowStyle:{
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 1, color: 'rgba(246, 232, 87,0)' // 0% 处的颜色
                                }, {
                                    offset: 0, color: 'rgba(234, 205, 44,0.4)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }  
                    }
                },                
                xAxis: {
                     splitLine: {
                        // show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'solid',
                            // width:1,
                        },
                        minInterval:0
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                    type: 'category',                              
                    data: this.viewdate,
                },
                yAxis: {
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        // show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                },
                series: [{
                    id:'a1',
                    
                    name:"路过客流",
                    data: this.viewdata.data1,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#43d3c9"
                        },                  
                    },
                    barWidth:this.barWidth     
                },
                {
                    id:'a2',
                     name:"进店客流",
                    data: this.viewdata.data2,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#2d99ff"
                        },                  
                    },
                    barWidth:this.barWidth   
                },
                {
                    id:'a3',
                    name:"试衣数",
                    data: this.viewdata.data3,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#8943d3"
                        },                  
                    },
                    barWidth:this.barWidth   
                },
                {
                    id:'a4',
                    name:"销售额",
                    data: this.viewdata.data4,
                    type: 'line',
                    itemStyle:{
                        normal:{ 
                            color:"#eacd2c"
                        },                  
                    }
                },
                
                ]
            }                        
            setTimeout(()=>{
                
                 that.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                  
                    })
               
            },500)  
        },
        rundata(){
     
           this.data.past.length>0&&(this.data.past.push(this.data.past.shift()))
            this.data.comeIn.length>0&&(this.data.comeIn.push(this.data.comeIn.shift()))
            this.data.fittingNum.length>0&&(this.data.fittingNum.push(this.data.fittingNum.shift()))
            this.data.saleTotal.length>0&&(this.data.saleTotal.push(this.data.saleTotal.shift()))
           this.datelist.length>0&&(this.datelist.push(this.datelist.shift()))   

        },
        //动画
        doit(){    
  
               let that=this
            if(this.timer){
                window.clearTimeout(that.timer);
            }
            this.timer= setTimeout(()=>{                             
                that.rundata()
            },3000)       
        },
    },
    mounted(){      
    }
}
</script>